module.exports = __webpack_public_path__ + "static/media/karwachauth.bc685a91.JPG";